import { graphql } from '@/gql';

export const InclusionFragment = graphql(`
  fragment InclusionFragment on InclusionStatus {
    __typename
    inclusionOf
    actual
    recommended
    source
    explanation
    reevaluationRequest
  }
`);

export const InformationsFragment = graphql(`
  fragment InformationsFragment on Information {
    id
    description
    link
    linkText
    classification
  }
`);

export const MaturityStageFragment = graphql(`
  fragment MaturityStageFragment on MaturityStage {
    id
    name
    description
    followingMaturityStages {
      id
      name
      description
      followingMaturityStages {
        id
        name
        description
      }
      triggeredDataBlocks {
        id
        name
      }
    }
    triggeredDataBlocks {
      id
      name
    }
  }
`);

export const getCompleteBBProduct = graphql(`
  query getCompleteBBProduct($id: ID!) {
    product(id: $id) {
      id
      name
      tailoringProcess {
        buildingBlocks {
          id
          productId
          name
          targetState
          why
          consequencesOfNoResponse
          applicableFor
          preconditionAssumptions
          definitionOfDone
          inclusion {
            ...InclusionFragment
          }
          designObligation {
            id
            name
            description
            inclusion {
              ...InclusionFragment
            }
            buildingBlocks {
              id
              productId
              name
            }
            informations {
              ...InformationsFragment
            }
          }
          informations {
            ...InformationsFragment
          }
          dataBlocks {
            id
            name
            description
            definitionOfDone
            inclusion {
              ...InclusionFragment
            }
            buildingBlocks {
              id
              productId
              name
            }
            neededByDataBlocks {
              id
              name
            }
            triggeredDataBlocks {
              id
              name
            }
            successorDataBlocks {
              id
              name
            }
            deadlineMaturityStages {
              ...MaturityStageFragment
            }
            competencies {
              id
              name
              description
            }
            informations {
              ...InformationsFragment
            }
          }
          maturityStages {
            ...MaturityStageFragment
          }
        }
      }
    }
  }
`);
